import React, { PropsWithChildren, useEffect, useState } from 'react';
import { Button, Dropdown } from 'react-bootstrap';
import { t } from 'i18next';

interface SearchFilterDropdownProps {
  CloseButtonText?: string;
  ShowCloseButton?: boolean;
  DefaultValue: boolean | null | number | string;
  FullWidth?: boolean;
  Id: string;
  Label: string;
  MinWidth?: number;
  Value?: boolean | null | number | string;
}

function SearchFilterDropdown(
  props: PropsWithChildren<SearchFilterDropdownProps>,
) {
  const {
    CloseButtonText = t('basicSearchFilters:filters.interhomeService'),
    ShowCloseButton = true,
    DefaultValue,
    FullWidth = false,
    Id,
    Label,
    MinWidth = 200,
    Value = null,
    children,
  } = props;

  const defaultCssClass = 'me-16 mb-16';
  const [cssClasses, setCssClasses] = useState<string>(defaultCssClass);

  const HandleCloseButtonClick = () => {
    document.getElementById(Id)?.click();
  };

  useEffect(() => {
    if (
      Value !== null &&
      Value !== undefined &&
      Value.toString() !== DefaultValue?.toString()
    ) {
      setCssClasses(`btn-blue text-white ${defaultCssClass}`);
    } else {
      setCssClasses(defaultCssClass);
    }
  }, [Value]);

  return (
    <Dropdown
      className={`d-inline-block${
        FullWidth ? ' searchfilter-dropdown-fullwidth position-static' : ''
      }`}
    >
      <Dropdown.Toggle
        className={cssClasses}
        id={Id}
        size="sm"
        variant="filter"
      >
        {Label}
      </Dropdown.Toggle>
      <Dropdown.Menu
        align={FullWidth ? 'start' : null}
        className={`bg-white p-24${
          FullWidth ? ' searchfilter-dropdown-menu-fullwidth mx-24' : ''
        }`}
        style={{ minWidth: MinWidth }}
      >
        {children}
        {ShowCloseButton && (
          <Button
            className="mt-16 w-100"
            onClick={() => HandleCloseButtonClick()}
          >
            {CloseButtonText}
          </Button>
        )}
      </Dropdown.Menu>
    </Dropdown>
  );
}

// SearchFilterDropdown.defaultProps = {
//   CloseButtonText: 'Näytä tulokset',
//   FullWidth: false,
//   MinWidth: 200,
//   Value: null,
//   ShowCloseButton: true,
// };

export default SearchFilterDropdown;
export { SearchFilterDropdown };
export type { SearchFilterDropdownProps };
